// extracted by mini-css-extract-plugin
export default {"centeredCheckbox":"CenteredCheckbox_centeredCheckbox__0xA5Y"};